import * as React from "react"
import {Box} from "@mui/material"
import {useAppToast} from "@ui-seeker/app"
import {ButtonLoadingSeeker, IconSeeker} from "@ui-seeker/core"
import {postSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants"
import {useUserApp} from "@hooks";
import {newProductsLoadingRow, newProductsTableData} from "../../../@signals"

export default function SkipButton({ rowData }) {

    const { showToast } = useAppToast()
    const { username } = useUserApp()

    const handleClick = () => showToast.confirm(`Are you sure you want to skip the following ${rowData?.productTitle}`, {
        onSubmit: () => {
            newProductsLoadingRow.value = [...newProductsLoadingRow.value, rowData.key]
            postSubmit(`${BACKEND_APIS.UNMATCHED}/new-products/update-mapping`, {
                brandID: rowData.brandID,
                skuID: 0,
                productID: rowData.productID,
                siteID: rowData.siteID,
                skip: true,
                validated: true,
                qa: true,
                username: username,
                rowKey: rowData.key
            }).then((res) => {
                newProductsTableData.value = newProductsTableData.value.filter(row => row.key !== res.rowKey)
                newProductsLoadingRow.value = [...newProductsLoadingRow.value.filter(key => key !== res.rowKey)]
            }).catch(() => console.log('ERROR EXTERNAL MAPPING SKU'))
        },
    })

    return <Box component="span">
        <ButtonLoadingSeeker
            loading={false}
            label="Skip"
            startIcon={<IconSeeker icon={'forward'} />}
            onClick={handleClick}
        >
            Skip
        </ButtonLoadingSeeker>
    </Box>
}